import { hFetch } from '@/lib/hfetch';
import type {
  MonthlyMarketingBudgetUpdateRequestEntity,
  MonthlyMarketingBudgetUpdateRequestStatus,
} from '@/api/entity_types/MonthlyMarketingBudgetUpdateRequest';

export type ListBudgetUpdateRequestsParams = {
  status?: MonthlyMarketingBudgetUpdateRequestStatus;
};

export type ListBudgetUpdateRequestsResponse = {
  records: MonthlyMarketingBudgetUpdateRequestEntity[];
};

export const listBudgetUpdateRequests = async (params: ListBudgetUpdateRequestsParams = {}) => {
  const search = new URLSearchParams();
  if (params.status) search.append('status', params.status);
  const queryString = search.toString();
  return await hFetch<ListBudgetUpdateRequestsResponse>({
    url: `/api/monthly_marketing_budget_update_requests${queryString ? `?${queryString}` : ''}`,
  });
};

export type CreateBudgetUpdateRequestParams = {
  total_spend: number;
  indeed_spend: number;
  zip_spend: number;
  monster_spend: number;
  meta_spend: number;
  reason: string;
  management_fee_consent: boolean;
};

export const createBudgetUpdateRequest = async (params: CreateBudgetUpdateRequestParams) => {
  return await hFetch<MonthlyMarketingBudgetUpdateRequestEntity, CreateBudgetUpdateRequestParams>({
    url: '/api/monthly_marketing_budget_update_requests',
    method: 'POST',
    payload: params,
  });
};
